import axios from "axios";
import Swal from "sweetalert2";

export const instance = axios.create({
  // baseURL: "http://localhost:5000/api",
  baseURL: "https://lipia-api.kreativelabske.com/api",
  // baseURL: "https://lipia-api.devriz.xyz/api",
});

// Set the AUTH token for any request
instance.interceptors.request.use((config) => {
  const token = JSON.parse(localStorage.getItem("token"));
  config.headers.Authorization = token ? `Bearer ${token}` : "";
  return config;
});

//handle token fails

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // if (error.response.status === 401) {

    // }

    if (error.response.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("authenticated");
      localStorage.removeItem("user");
      Swal.fire("Session Expired", "Token expired, Login!!", "error")
      return (window.location.href = "/login");
    }

    return Promise.reject(error);
  }
);
